<template>
    <Page>
        <Container>
            <div class="mx-auto max-w-sm">
                <LogResourceList :key="$route.fullPath" />
            </div>
        </Container>
    </Page>
</template>

<script>
import {defineComponent} from 'vue'
import LogResourceList from '@/components/Log/ResourceList.vue';

export default defineComponent({
  name: 'Index',
  components: {
    LogResourceList,
  },
});
</script>

<style scoped lang="scss">

</style>
